import { combineReducers } from 'redux';

//reducers
import scheduleReducer from './schedule/scheduleReducer';

export default combineReducers({
    schedule: scheduleReducer
});